module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/og_page2-B.181b9f29.jpg";